import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(private authService: AuthService, private router: Router) {
   }

  ngOnInit() {
    //console.log(this.authService.isTokenExpired());
    if(this.authService.isTokenExpired()){
      this.authService.refreshlogIn().subscribe(res=>{
       // console.log('refreshed');
      },err=>{this.authService.destroyUserCredentials();
      });
    };
  }

}
